export default {
    setTicketsAbiertos(state, a) {
        state.ticketsAbiertos = a;
    }
}